export default "__VITE_ASSET__8x5DSiON__"